import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
// import LogoImage from '../../assetsold/img/pci-logo-text.png'
import URL from '../../constants/urls'
import noop from 'lodash/noop'
import { globalKeyStore } from '../../redux/actions/globalState'
import { getName, isPermissionExist, loggedInUserData, sortPortalPermissionByKey } from '../../utils/helper'
import Login from '../loginCom'
import { getConfigDetails } from '../../services/config'

function NavbarComponent(props) {
	const navigate = useNavigate()
	const { globalData, isOpened, dispatch, isLoggedIn, notify, userDetails, isAuthenticated, logoImage } = props
	const getAccessPermissionData = sortPortalPermissionByKey(globalData, 'Access Permissions')
	const { pathname } = useLocation()
	const user = window.location.toString().split('/')[3]
	const facility = window.location.toString().split('/')[4]
	useEffect(() => {
		const partnerDataLoc = JSON.parse(localStorage.getItem('partnerData'))
		dispatch(globalKeyStore({ logoImage: partnerDataLoc?.brand_setting?.logourl }))
	}, [])

	useEffect(() => {
		const pageURL = pathname.split('/')
		if (pageURL[pageURL.length - 1] !== 'bookingdetail') {
			localStorage?.removeItem('booking_event')
		}
	}, [pathname])

	useEffect(() => {
		const getuserDatafromLocal = JSON.parse(localStorage.getItem('userData'))
		const isLoggedInlocalState = JSON.parse(localStorage.getItem('isLoggedIn'))

		if (isAuthenticated || getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token !== '') {
			// for is logined true 
			dispatch(globalKeyStore({ isLoggedIn: isLoggedInlocalState }))
			if (getuserDatafromLocal?.access_token && getuserDatafromLocal?.access_token !== '') {
				if ((getuserDatafromLocal?.user?.first_name && getuserDatafromLocal?.user?.first_name != '')) {
					dispatch(globalKeyStore({ isLoggedIn: true }))
					dispatch(globalKeyStore({ userDetails: getuserDatafromLocal?.user }))
				} else {
					dispatch(globalKeyStore({ userDetails: getuserDatafromLocal?.user }))
				}
			}
		}
	}, [isAuthenticated, logoImage])

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [pathname])

	const handleLogout = () => {
		localStorage.removeItem('userData')
		localStorage.removeItem('isLoggedIn')
		localStorage.removeItem('masquerade')
		dispatch(globalKeyStore({ isLoggedIn: false, userDetails: {} }))
		navigate(0)
	}


	const handleActiveTab = () => {
		dispatch(globalKeyStore({ isOpened: false }))
		var navbarDiv = document.getElementById('navbarSupportedContent')
		navbarDiv.classList.remove('show')
	}

	const handleDropDown = (e) => {
		e.stopPropagation()
		if (isOpened) {
			dispatch(globalKeyStore({ isOpened: false }))
		} else {
			dispatch(globalKeyStore({ isOpened: true }))
		}
	}

	const handleModalOpen = () => {
		dispatch(globalKeyStore({ isLoginModal: true }))
	}


	const handleMyAccountView = () => {
		// setMenuDisplay(false)
		window.open(`${getConfigDetails()?.portalURL}/navigating/${loggedInUserData()?.access_token}/${loggedInUserData()?.refresh_token}/1/${user}`, '_self')
	}

	const handleProfileView = () => {
		// setMenuDisplay(false)
		window.open(`${getConfigDetails()?.portalURL}/navigating/${loggedInUserData()?.access_token}/${loggedInUserData()?.refresh_token}/2/${user}`, '_self')
	}



	return (
		<div>
			<header className="w-100 bg-light shadow">
				<nav className="navbar navbar-expand-lg" data-bs-theme="light">
					<div className="container">
						<a className="navbar-brand" href={facility && Number.isInteger(Number(facility)) ? `/${user}/${facility}` : `/${user}`}><img height="40px" src={logoImage} alt='' /></a>

						<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>

						<div className="collapse navbar-collapse" id="navbarSupportedContent">
							<ul className="navbar-nav ms-auto mb-2 mb-lg-0">
								{globalData?.['Main Menu']?.map((item, index) => {
									if (item?.display_name == 'Home') {
										return <li className="nav-item fw-bold" key={index}>
											<Link className={((pathname == `${URL?.INDEX}`) || (item?.web == `${item?.web}`)) ? 'nav-link activeLink' : 'nav-link'} to={`${item?.web}`} onClick={() => handleActiveTab()}>{item?.display_name}</Link>
										</li>
									} else if (item?.display_name == 'Profile') {
										return <li className="nav-item fw-bold" key={index}>
											<Link className={((pathname == `${URL?.INDEX}`) || (item?.web == `${item?.web}`)) ? 'nav-link activeLink' : 'nav-link'} to={`${item?.web}`} onClick={() => handleActiveTab()}>{item?.display_name}</Link>
										</li>
									} else if (item?.subValues && item?.subValues?.length > 0) {
										return <li className="nav-item fw-bold dropdown" key={index}>
											<a className="nav-link dropdown-toggle" href={`/${user}`} role="button" data-bs-toggle="dropdown" aria-expanded="false">{item?.display_name}</a>
											<ul className="dropdown-menu">
												{item?.subValues?.map((subItem, subIndex) => {
													return (
														<li key={subIndex}>
															<a className="dropdown-item" href={`/${user}`}>{subItem?.display_name}</a>
															{(item?.isDiv == (subIndex + 1)) ? <hr className="dropdown-divider" /> : ''}
														</li>
													)
												})}
											</ul>
										</li>
									} else if (item?.display_name == 'Permit Purchase') {
										return <li className="nav-item fw-bold" key={index}>
											<Link className={((pathname == `/${item?.web}`)) ? 'nav-link activeLink' : 'nav-link'} to={`${getConfigDetails()?.portalURL}/${user}`} onClick={() => handleActiveTab()}>{item?.display_name}</Link>
										</li>
									} else if (item?.display_name == 'Book Event') {
										return <li className="nav-item fw-bold" key={index}>
											<Link className={((pathname == `/${item?.web}`)) ? 'nav-link activeLink' : 'nav-link'} to={`/${user}`} onClick={() => handleActiveTab()}>{item?.display_name}</Link>
										</li>
									} else {
										return <li className="nav-item fw-bold" key={index}>
											<Link className={((pathname == `/${item?.web}`)) ? 'nav-link activeLink' : 'nav-link'} to={`${getConfigDetails()?.portalURL}/${user}${item?.web}`} onClick={() => handleActiveTab()}>{item?.display_name}</Link>
										</li>
									}
								})}
							</ul>

							<div className="ms-0 ps-0">
								{isLoggedIn ?
									<div className="dropdown">
										<button className="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" onClick={(e) => handleDropDown(e)}>{getName(userDetails)}</button>
										<ul className="dropdown-menu p-0">
											{(isPermissionExist(getAccessPermissionData, 'Account Access')) && <li>
												<span role='button' className={(pathname == `/${URL?.USER_ACCOUNT}`) ? 'dropdown-item nav-link activeLink ps-2 py-2' : 'dropdown-item nav-link ps-2 py-2'} onClick={() => handleMyAccountView()}>My Account</span>
											</li>}
											<li> <hr className="dropdown-divider m-0" /></li>
											{(isPermissionExist(getAccessPermissionData, 'Profile Access')) && <li>
												<span role='button' className={(pathname == `/${URL?.PROFILE}`) ? 'dropdown-item nav-link activeLink ps-2 py-2' : 'dropdown-item nav-link ps-2 py-2'} onClick={() => handleProfileView()}>Profile</span>
											</li>}
											<li> <hr className="dropdown-divider m-0" /></li>
											<li><button type='button' className="dropdown-item p-0 ps-2 py-2" onClick={(e) => handleLogout(e)}>Logout</button></li>
										</ul>
									</div> : (isPermissionExist(getAccessPermissionData, 'Login Access')) && <li className="btn btn-outline-primary" onClick={handleModalOpen}><i className=" fa fa-user me-2"></i>login </li>}
							</div>
						</div>
					</div>
				</nav>
				<Login notify={notify} />
			</header>
		</div>
	)
}


NavbarComponent.propTypes = {
	dispatch: PropTypes.func,
	isAuthenticated: PropTypes.bool,
	userData: PropTypes.object,
	isModalOpen: PropTypes.bool,
	globalData: PropTypes.object,
	isOpened: PropTypes.bool,
	isLoggedIn: PropTypes.bool,
	notify: PropTypes.func,
	userDetails: PropTypes.object,
	logoImage: PropTypes.string
}

NavbarComponent.defaulProps = {
	dispatch: noop,
	isAuthenticated: false,
	userData: EMPTY_OBJECT,
	isModalOpen: false,
	globalData: EMPTY_OBJECT,
	isOpened: false,
	isLoggedIn: false,
	notify: noop,
	userDetails: EMPTY_OBJECT,
	logoImage: ''
}

function mapStateToProps({ loginReducer, basicInfoReducer, globalReducers }) {
	return {
		isAuthenticated: loginReducer?.isAuthenticated,
		isModalOpen: basicInfoReducer?.isModalOpen,
		globalData: globalReducers?.partnerDetails?.customer_portal_permission,
		isLoggedIn: globalReducers?.isLoggedIn,
		isOpened: globalReducers?.isOpened,
		userDetails: globalReducers?.userDetails ? ((Object.keys(globalReducers?.userDetails).length > 0) ? globalReducers?.userDetails : EMPTY_OBJECT) : (loginReducer?.data?.data?.user ? loginReducer?.data?.data?.user : EMPTY_OBJECT),
		logoImage: globalReducers?.logoImage
	}
}
export default connect(mapStateToProps)(NavbarComponent)
